export const supportedLocales = ['en-US', 'en-CA', 'fr-CA'] as const

export type Locale = (typeof supportedLocales)[number]
export type LocaleLowerCase = Lowercase<Locale>

export const supportedCurrencies = ['USD', 'CAD'] as const
export type Currency = (typeof supportedCurrencies)[number]

export type CountryCode = 'US' | 'CA'
